import React, { useEffect, useState } from "react";

import './MediaThumbnail.scss';
import { playIcon } from "shared/assets/icons";

export const MediaThumbnail = ({ url, thumbnailCallback, onClickCallback }) => {
    const [thumbnail, setThumbnail] = useState(null);

    useEffect(() => {
        const video = document.createElement("video");
        video.crossOrigin = "anonymous";
        video.src = url;
        video.muted = true;
        video.playsInline = true;
        video.preload = "metadata";
        video.autoplay = true;
        video.style.display = "none";

        video.addEventListener("loadedmetadata", () => {
            let seekTime = 1;
            if (seekTime > video.duration) {
                seekTime = 0;
            }
            video.currentTime = seekTime;
        });

        video.addEventListener("seeked", () => {
            const canvas = document.createElement("canvas");

            // Dimensions are reduced to 30%
            canvas.width = ( 30 / 100 ) * video.videoWidth;
            canvas.height = ( 30 / 100 ) * video.videoHeight;

            const ctx = canvas.getContext("2d");
            ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

            const thumbnailDataUrl = canvas.toDataURL("image/png");

            video.pause();
            video.removeAttribute("src"); // Clear source
            video.load();                 // Reset media pipeline
            video.remove();               // Remove from DOM

            setThumbnail(thumbnailDataUrl);

            thumbnailCallback && thumbnailCallback(thumbnailDataUrl);
        });

        video.onerror = (error) => {
            // TODO have a default video thumbnail if the video is errored.
            console.log("error while generating thumbnail of video", error)
        };
    }, [url]);

    return (
        thumbnail ? 
        <div className="media-thumbnail">
            <img className="thumbnail-image" src={thumbnail} />
            <div className="play-icon" onClick={() => onClickCallback && onClickCallback()}>
                {playIcon}
            </div>
        </div> : null
    );
}

export const MediaThumbnailsSync = ({ videos, thumbnailCallback }) => {

    useEffect(() => {
        generateAllThumbnails();
    }, [videos]);

    const generateAllThumbnails = async () => {
        if ( Array.isArray(videos) && videos.length > 0 ) {
            for (const index in videos) {
                const asset = videos[index];
                await generateThumbnail(asset.url).then((thumbnailDataUrl) => {
                    thumbnailCallback && thumbnailCallback({ [asset.id]: thumbnailDataUrl });
                }).catch(error => {
                    console.log("Error while generating thumbnail of a video", asset, error);
                });
            }
        }
    };

    const generateThumbnail = (url) => {
        return new Promise((resolve, reject) => {
            try {
                const video = document.createElement("video");
                video.crossOrigin = "anonymous";
                video.src = url;
                video.muted = true;
                video.playsInline = true;
                video.preload = "metadata";
                video.autoplay = true;
                video.style.display = "none";

                video.addEventListener('canplay', () => {
                    video.currentTime = 1 < video.duration ? 1 : 0;
                });
        
                video.addEventListener("seeked", () => {
                    let thumbnailDataUrl = null;

                    if ( video.videoWidth && video.videoHeight ) {
                        const canvas = document.createElement("canvas");

                        // Dimensions are reduced to 30%
                        canvas.width = ( 30 / 100 ) * video.videoWidth;
                        canvas.height = ( 30 / 100 ) * video.videoHeight;
        
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                        const frameData = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
                        const isBlank = frameData.every((v, i) => i % 4 === 3 || v === 0 || v === 255);

                        thumbnailDataUrl = isBlank ? `${process.env.PUBLIC_URL}/static/icons/common-icons/default-video-thumbnail.jpg` : canvas.toDataURL("image/webp");

                    } else {
                        thumbnailDataUrl = `${process.env.PUBLIC_URL}/static/icons/common-icons/default-video-thumbnail.jpg`;
                    }
                
                    video.pause();
                    video.removeAttribute("src"); // Clear source
                    video.load();                 // Reset media pipeline
                    video.remove();               // Remove from DOM

                    video.removeEventListener("canplay", () => {});
                    video.removeEventListener("seeked", () => {});
        
                    resolve(thumbnailDataUrl);
                });
        
                video.onerror = (error) => {
                    reject(error);
                };

                video.load();

            } catch (error) {
                reject(error);
            }
        });
    }

    return null;
};